import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import Image from "components/Image";
import Input from "components/Input/Input";
import NcLink from "components/NcLink/NcLink";
import { useRegisterMutation } from "framework/rest/auth/auth.query";
import googleSvg from "images/Google.svg";
import { useAtom } from "jotai";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { authorizationAtom } from "store/atom/auth";
import { settingsAtom } from "store/atom/settings.atom";
import { AUTH_TOKEN } from "utils/constants";
import Layout from "../layout";

const loginSocials = [
    // {
    //     name: "Continue with Facebook",
    //     href: "#",
    //     icon: facebookSvg,
    // },
    // {
    //     name: "Continue with Twitter",
    //     href: "#",
    //     icon: twitterSvg,
    // },
    {
        name: "Continue with Google",
        href: "#",
        icon: googleSvg,
    },
];

interface LoginInputType {
    email: string;
    password: string;
    name: string;
}

const PageSignUp = () => {
    const { mutate: registerUser, isLoading: loading } = useRegisterMutation();
    const router = useNavigate();
    const defaultValues = {
        email: "",
        password: "",
        name: "",
    };
    const { register, handleSubmit } = useForm({
        defaultValues,
    });
    const [, authorize] = useAtom(authorizationAtom);
    const [settings, _] = useAtom(settingsAtom);

    const onSubmit = async ({ email, password, name }: LoginInputType) => {
        registerUser(
            {
                name,
                email,
                password,
            },
            {
                onSuccess: (data) => {
                    if (data?.token && data?.permissions?.length) {
                        Cookies.set(AUTH_TOKEN, data.token);
                        authorize(true);
                        return router("/");
                    }
                },
                onError: (error: any) => {},
            }
        );
    };

    return (
        <Layout>
            <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20">
                <Heading2>Kayıt Ol</Heading2>
                <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
                    Kayıt olabilir veya giriş yapabilirsiniz.
                </span>
            </header>

            <div className="max-w-md mx-auto space-y-6">
                {settings.homepage.login.google && (
                    <>
                        <div className="grid gap-3">
                            {loginSocials.map((item, index) => (
                                <a
                                    key={index}
                                    href={item.href}
                                    className=" flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]"
                                >
                                    <Image className="flex-shrink-0" src={item.icon} alt={item.name} />
                                    <h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">
                                        {item.name}
                                    </h3>
                                </a>
                            ))}
                        </div>
                        {/* OR */}
                        <div className="relative text-center">
                            <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
                                ve
                            </span>
                            <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
                        </div>
                    </>
                )}
                {/* FORM */}
                <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit(onSubmit)}>
                    <label className="block">
                        <span className="text-neutral-800 dark:text-neutral-200">Adınız</span>
                        <Input
                            type="text"
                            placeholder="Name"
                            className="mt-1"
                            {...register("name", { required: true })}
                        />
                    </label>

                    <label className="block">
                        <span className="text-neutral-800 dark:text-neutral-200">E-posta adresi</span>
                        <Input
                            type="email"
                            placeholder="example@example.com"
                            className="mt-1"
                            {...register("email", { required: true })}
                        />
                    </label>
                    <label className="block">
                        <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                            Şifre
                            <NcLink href="/forgot-pass" className="text-sm underline">
                                Şifremi unuttum
                            </NcLink>
                        </span>
                        <Input type="password" className="mt-1" {...register("password", { required: true })} />
                    </label>
                    <ButtonPrimary type="submit">Giriş</ButtonPrimary>
                </form>

                {/* ==== */}
                <span className="block text-center text-neutral-700 dark:text-neutral-300">
                    Hesabınız var mı?
                    <NcLink href="/login"> Giriş yapın</NcLink>
                </span>
            </div>
        </Layout>
    );
};

export default PageSignUp;
